import React from 'react';

export class Footer extends React.Component {
  render = () => (
    <footer>
      <div className="about__blocks">
        <div>
          <label>contact us</label>
          <a href="mailto:info@kioskradio.com">info@kioskradio.com</a>
        </div>
        <div>
          <label>drop by</label>
          Place des Palais 10<br/>1000 Brussels, Belgium
        </div>
        <div>
          <label>tune in</label>
          Anytime.<br/>Anywhere.
        </div>
      </div>
      <div className="about__brussels">
        <div className="about__brussels__logos">
          <div><img src="/images/be-brussels.svg" alt="Brussels-Capital Region" /></div>
          <div><img src="/images/brussels.svg" alt="City of Brussel" /></div>
        </div>
        <p>Kiosk Radio is supported by City of Brussels and the Brussels-Capital Region.</p>
      </div>
    </footer>
  )
}